<!-- Top Bar -->
<div
  class="global__top-bar__height d-flex align-items-center fs-18px font-weight-bold pl-15px border-bottom border-color-grey"
>
  <top-bar-mobile-navigation-control
    class="mr-15px d-lg-none d-inline-block"
  ></top-bar-mobile-navigation-control>

  Send $DESO
</div>

<!-- Explainer -->
<div
  class="d-flex align-items-center fs-15px fc-muted p-15px border-bottom border-color-grey background-color-light-grey"
>
  Sending $DESO is easy. Just enter a public key below and the protocol will
  handle the rest.
</div>

<div class="fs-15px font-weight-bold mt-15px px-15px">
  Public key or username to pay:
  <!-- Search Bar -->
  <search-bar
    [showCloutavista]="false"
    [startingSearchText]="startingSearchText"
    [isSearchForUsersToSendDESO]="true"
    (creatorToMessage)="_handleCreatorSelectedInSearch($event)"
  ></search-bar>
</div>

<div class="px-5px">
  <simple-profile-card
    [profile]="payToCreator"
    [singleColumn]="true"
    [hideFollowLink]="true"
    *ngIf="payToCreator"
  ></simple-profile-card>
</div>

<div class="fs-15px font-weight-bold mt-15px px-15px">
  Amount of $DESO to send:
</div>
<div class="d-flex align-items-center px-15px mt-5px">
  <input
    type="number"
    class="form-control w-100 fs-15px lh-15px"
    placeholder="0"
    [(ngModel)]="transferAmount"
  />
  <button
    *ngIf="!loadingMax"
    class="btn btn-primary font-weight-bold fs-15px ml-5px py-10px"
    style="line-height: 15px; border-radius: 3px"
    (click)="_clickMaxDeSo()"
  >
    Max
  </button>
  <button
    *ngIf="loadingMax"
    class="btn btn-primary font-weight-bold fs-15px ml-5px py-10px"
    style="line-height: 15px; border-radius: 3px"
    disabled
  >
    Loading...
  </button>
</div>

<div class="fs-15px font-weight-bold mt-15px px-15px">Network Fee:</div>
<div
  class="d-flex align-items-center fs-15px lh-15px pl-15px mt-5px ml-15px mr-15px border border-color-grey background-color-light-grey"
  style="height: 40px; border-radius: 3px"
>
  {{ globalVars.nanosToDeSo(networkFee * 1e9) }}
  (≈ {{ globalVars.nanosToUSD(networkFee * 1e9) }} USD)
</div>

<div class="fs-15px font-weight-bold mt-15px px-15px">Total:</div>
<div
  class="d-flex align-items-center fs-15px lh-15px pl-15px mt-5px ml-15px mr-15px mb-15px border border-color-grey background-color-light-grey"
  style="height: 40px; border-radius: 3px"
>
  {{ globalVars.nanosToDeSo((transferAmount + networkFee) * 1e9) }}
  (≈ {{ globalVars.nanosToUSD((transferAmount + networkFee) * 1e9) }} USD)
</div>

<div *ngIf="transferDeSoError != ''" class="fs-15px fc-red ml-15px pb-15px">
  {{ transferDeSoError }}
</div>

<button
  *ngIf="!sendingDeSo"
  class="btn btn-primary font-weight-bold fs-15px ml-15px py-10px mt-5px"
  style="line-height: 15px; border-radius: 3px"
  (click)="_clickSendDeSo()"
>
  Send DeSo
</button>

<button
  *ngIf="sendingDeSo"
  class="btn btn-primary font-weight-bold fs-15px ml-15px py-10px mt-5px"
  style="line-height: 15px; border-radius: 3px"
  disabled
>
  Working...
</button>

<div class="p-15px d-flex flex-column align-items-center">
  <p>
    Scan QR code to send
    {{ globalVars.loggedInUser.ProfileEntryResponse?.Username }} $DESO
  </p>
  <img [src]="sendDeSoQRCode | sanitizeQRCode" />
</div>

<!-- SPACER FOR BOTTOM BAR ON MOBILE -->
<div class="global__bottom-bar-mobile-height"></div>
